import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { IrspaLetterContentForm } from './forms/irspa-letter-content-form';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../common/validation-errors/validation-errors.component';
import { updateApplication } from '../../../../../store/actions/application.actions';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  DrawAndModifyTerrainComponent
} from '../../../../../common/draw-and-modify-terrain/draw-and-modify-terrain.component';
import { AlertComponent } from '../../../../../common/alert/alert.component';
import { ShipmentContentLabelPipe } from '../../../../../pipes/shipment-content/shipment-content-label.pipe';
import {
  ShipmentContentPlaceholderPipe
} from '../../../../../pipes/shipment-content/shipment-content-placeholder.pipe';

export type DefaultShipmentType =
  'Wniosek do projektu aktu'
  | 'Uwaga do konsultowanego projektu aktu'
  | 'Wniosek o zmianę aktu'
  | 'Wniosek o sporządzenie aktu';

export interface IrspaLetterContentComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
  defaultShipmentTypeValue: DefaultShipmentType;
  addGeometryControl?: boolean;
}

@Component({
  selector: 'app-irspa-letter-content-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    LabelComponent,
    DrawAndModifyTerrainComponent,
    AlertComponent,
    ShipmentContentLabelPipe,
    ShipmentContentPlaceholderPipe
  ],
  providers: [IrspaLetterContentForm],
  templateUrl: './irspa-letter-content-section.component.html'
})
export class IrspaLetterContentSectionComponent implements OnInit, OnDestroy {

  public stages: string[] = this.route.snapshot.data['stages'];

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public defaultShipmentTypeValue: string | undefined = this.route.snapshot.data['defaultShipmentTypeValue'];

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
    this.showDrawTerrain = !app?.geometry;
  });

  public showDrawTerrain = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: IrspaLetterContentForm
  ) {
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.applicationId || '',
        application: { ...this.form.toWriteModel(), shipmentType: this.defaultShipmentTypeValue },
        successFnc: () => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate([this.cancelUrl], { relativeTo: this.route });
  }

  public ngOnInit(): void {
    if (this.route.snapshot.data['addGeometryControl']) {
      this.form.createGeometryControl();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
